module.exports = __webpack_public_path__ + "static/media/294092.74823400.png";